import {
  Badge,
  Body,
  Group,
  H6,
  MaterialIcon,
  Stack,
} from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import useStepConfig from '../Steps/useStepConfig';
import { CheckpointStepContent } from './Checkpoint.styled';
import { CheckpointFooter } from './CheckpointFooter';
import { Timeline } from './Timeline';

export const Checkpoint = () => {
  const t = useTranslate();
  const {
    applicationCanHaveGuarantors,
    turnoverQuestionIsAfterCheckpoint,
  } = useStepConfig();

  const items: React.JSX.Element[] = [
    <Stack key="basic_application_sent" spacing="sm" mt={3}>
      <H6>{t('Onboarding.CheckpointTitle')}</H6>
      <Body size="lg" mb="xxl">
        {t('Onboarding.CheckpointDescription')}
      </Body>
    </Stack>,

    ...(applicationCanHaveGuarantors
      ? [
          <Group
            key="guarantors_step"
            align="center"
            justify="space-between"
            w="100%"
          >
            <Body>{t('Onboarding.CheckpointGuarantorsStep')}</Body>
            <Badge color="Main/Grey/300" size="sm">
              {t('Onboarding.CheckpointIncompleteStep')}
            </Badge>
          </Group>,
        ]
      : []),

    <Group
      key="turnover_steps"
      align="center"
      justify="space-between"
      w="100%"
      pb={40}
    >
      <Body>
        {turnoverQuestionIsAfterCheckpoint
          ? t('Onboarding.CheckpointTurnoverStep')
          : t('Onboarding.CheckpointVerifyTurnoverStep')}
      </Body>
      <Badge color="Main/Grey/300" size="sm">
        {t('Onboarding.CheckpointIncompleteStep')}
      </Badge>
    </Group>,

    <Stack key="boosted_application" mt={3}>
      <H6>{t('Onboarding.CheckpointBoostedApplicationStep')}</H6>
      <Body size="lg">
        {t('Onboarding.CheckpointBoostedApplicationStepDescription')}
      </Body>
      <Stack m="sm">
        <Group align="center">
          <MaterialIcon
            src="star"
            bg="Container/Option_6_(Light_Green)"
            size={28}
          />
          <Body size="lg">
            {t('Onboarding.CheckpointBoostedApplicationStepDescriptionUSP1')}
          </Body>
        </Group>
        <Group align="center">
          <MaterialIcon
            src="speed"
            bg="Container/Option_6_(Light_Green)"
            size={28}
          />
          <Body size="lg">
            {t('Onboarding.CheckpointBoostedApplicationStepDescriptionUSP2')}
          </Body>
        </Group>
        <Group align="center">
          <MaterialIcon
            src="rocket_launch"
            bg="Container/Option_6_(Light_Green)"
            size={28}
          />
          <Body size="lg">
            {t('Onboarding.CheckpointBoostedApplicationStepDescriptionUSP3')}
          </Body>
        </Group>
      </Stack>
    </Stack>,
  ];

  return (
    <CheckpointStepContent>
      <Stack
        spacing={'xxl'}
        style={{
          overflow: 'auto',
          height: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Timeline items={items} completedIndex={1} />
        <CheckpointFooter />
      </Stack>
    </CheckpointStepContent>
  );
};
